import { extendTheme } from "@chakra-ui/react";

export const customTheme = extendTheme({
  colors: {
    black: "#000",
    white: "#fff",
    bg: {
      50: "#eef1f9",
      100: "#d3d7de",
      200: "#b7bbc6",
      300: "#9ba1af",
      400: "#7d8598",
      500: "#646c7f",
      600: "#4e5463",
      700: "#373c47",
      800: "#21242c",
      900: "#090c14",
    },
    hyper: {
      50: "#eaf3fe",
      100: "#ccd8e7",
      200: "#adbfd2",
      300: "#8da5bf",
      400: "#6d8bac",
      500: "#547292",
      600: "#405972",
      700: "#2d3f52",
      800: "#192633",
      900: "#010e16",
    },
    headline: {
      50: "#e0f9fc",
      100: "#c4e5e9",
      200: "#a4d1d7",
      300: "#84bdc7",
      400: "#63aab5",
      500: "#4a919c",
      600: "#36707a",
      700: "#245158",
      800: "#0f3136",
      900: "#001316",
    },
    primarytxt: {
      50: "#eef1fd",
      100: "#d0d6e3",
      200: "#b3bbcb",
      300: "#969fb6",
      400: "#7874a0",
      500: "#5e6a87",
      600: "#495369",
      700: "#343b4c",
      800: "#1e2330",
      900: "#050c16",
    },
    button: {
      50: "#ffece7",
      100: "#edccc5",
      200: "#ddaba2",
      300: "#ce897d",
      400: "#bf6958",
      500: "#a64f3f",
      600: "#823e31",
      700: "#5d2b22",
      800: "#391914",
      900: "#1a0601",
    },
  },
});
